var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('header',[_c('h5',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('section',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }